import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Modal,
  ModalBody,
  FormGroup,
  Label,
  Input,
  Table,
  Button,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import {
  fetchCategories,
  statusUpdateService,
  Featured,
} from "../../../components/Header/Data";
import { useNavigate } from "react-router-dom";
import Placeholder from "../../../assets/images/Placeholder.png";
import { toast } from "react-toastify";
import { VscKebabVertical } from "react-icons/vsc";
import { MdEdit, MdDelete } from "react-icons/md";
import { FcApprove } from "react-icons/fc";
import "./Services.css";
import axiosClient from "../../../axios-client";
import moment from "moment";
import { createGetCustomerSetting } from "../../../components/Header/Data3";
const PendingServices = ({ pending, user, fetchData, isLoading }) => {
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [limit, setLimit] = useState("");
  const [limitService, setLimitService] = useState(null);
  const [limitModal, setLimitModal] = useState(false);
  const [gottonData, setGottonData] = useState({});
  const navigate = useNavigate();
  // const history = useHistory();
  const fetchCatData = async () => {
    try {
      const categoriesData = await fetchCategories();
      setCategories(categoriesData);
    } catch (error) {
      console.error("Error fetching categories:", error.message);
    }
  };
  const onEdit = async (service) => {
    navigate("/create-service", { state: service });
  };
  const onDelete = async (service) => {
    const reqData = {
      Status: "2",
      createdBy: user.UserID,
    };
    await statusUpdateService(reqData, service.Id);
    toast.success(`${service.listName} Deleted`);
    fetchData();
  };
  const onApprove = async (service) => {
    console.log(service, "service");
    if (service.dialExtension === null) {
      toast.error("Please add Dial Extension");
      return;
    }
    if (!limit || limit === null || limit === 0) {
      toast.error("Please enter valid limit");
      return;
    }
    const reqData = {
      Status: "3",
      createdBy: user.UserID,
      roleId: user.RoleId,
    };

    let formData = {
      userId: +service?.createdBy,
      Month:
        gottonData?.MONTH || moment(`${monthName} ${year}`).format("YYYY-MM"),
      getCustomerLimit: +limit,
    };
    console.log(formData, "formData");
    await createGetCustomerSetting(formData);
    await statusUpdateService(reqData, service.Id);
    toast.success(`${service.listName} Approved`);
    fetchData();
    setLimitModal(false);
    setLimitService(null);
  };

  useEffect(() => {
    fetchCatData();
    console.log(pending, "pending");
  }, []);

  useEffect(() => {
    // Filter categories based on pending data
    if (categories.length > 0 && pending.length > 0) {
      const categoryIds = pending.map((service) => service.categoryId);
      const filtered = categories.filter((category) =>
        categoryIds.includes(category.Id.toString())
      );
      setFilteredCategories(filtered);
    }
  }, [categories, pending]);

  const toggleMenu = (adId, event) => {
    event.stopPropagation();
    setOpenMenuId(openMenuId === adId ? null : adId);
    if (openMenuId === adId) {
      document.addEventListener("click", handleDocumentClick);
    } else {
      document.removeEventListener("click", handleDocumentClick);
    }
  };

  const handleDocumentClick = (event) => {
    if (event.target.closest(".service-menu") === null) {
      setOpenMenuId(null);
    }
  };

  function getMinPackagePrice(packageData) {
    const packages = Object.values(packageData);
    const prices = packages.map((userpackage) =>
      parseFloat(userpackage.totalPrice)
    );
    const minPrice = Math.min(...prices);
    return minPrice;
  }

  console.log(pending, "pending");

  const today = new Date();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monthName = monthNames[today.getMonth()];
  const year = today.getFullYear();
  const fetchGotton = async () => {
    try {
      const response = await axiosClient.put(
        `message/TotalMsgMonthGetCustomer/${parseInt(limitService?.createdBy)}`
      );
      const data = response.data.Data; // Ensure this matches the API response structure
      const currentMonth = new Date().getMonth() + 1; // Get current month (1-12)
      const currentYear = new Date().getFullYear(); // Get current year
      const currentMonthStr = currentMonth.toString().padStart(2, "0");
      // Filter current month data
      const filteredData = data.find((item) => {
        const itemMonth = item.MONTH.split("-")[1]; // Get month from item date
        const itemYear = item.MONTH.split("-")[0]; // Get year from item date
        console.log(
          currentMonth,
          itemMonth,
          currentYear,
          itemYear,
          "limitService.createdBy"
        );
        return (
          itemMonth === currentMonthStr && itemYear === currentYear.toString()
        );
      });
      console.log(filteredData, "filteredData");
      setGottonData(filteredData);
      setLimit(filteredData?.getCustomerLimit);
    } catch (error) {
      console.error("Error fetching Gotton data:", error);
    }
  };

  useEffect(() => {
    if (user) {
      fetchGotton();
    }
  }, [limitModal, user]);
  console.log(limitService, "limitService");
  console.log(gottonData, "gottonData");
  return (
    <>
      {pending.length > 0 ? (
        <div
          // sm={9}
          className="service-container mt-4 pb-3"
          style={{ marginLeft: "0" }}
        >
          {pending.map((service) => (
            <div
              className="service position-relative rounded px-0 mb-0 mt-3"
              key={service.Id}
            >
              <Row>
                <Col sm={3} xs={12} className=" p-0 position-relative">
                  <img
                    className="mw-100 object-fit-cover border rounded mh-100 img-fluid img-thumbnail"
                    src={
                      typeof service.Photo[0] === "string"
                        ? JSON.parse(service?.Photo)[0]
                        : Placeholder
                    }
                    style={{ width: "400px", height: "150px" }}
                    alt={service.listName}
                  />
                  {/* {service.featuredListing === 1 && (
                      <div className="featured">FEATURED</div>
                    )} */}
                </Col>
                <Col sm={9} xs={12} className=" p-3 position-relative">
                  <Row
                    className="top-0 end-0 pe-1"
                    style={{ right: "10px", top: "10px" }}
                  >
                    <Col sm={7} xs={12}>
                      <p>{service.categoryName}</p>
                    </Col>
                    <Col
                      sm={5}
                      xs={12}
                      className="postion-realtive text-end cursor-pointer"
                    >
                      {user.Role === "admin" && (
                        <button
                          className="p-1 px-2 mx-1 rounded text-white bg-opacity-75 btn-sm"
                          style={{ backgroundColor: "#1fa31f" }}
                          onClick={() => {
                            setLimitModal(true);
                            setLimitService(service);
                          }}
                        >
                          <FcApprove /> Approve
                        </button>
                      )}
                      <button
                        className="p-1 px-2 mx-1 bg-primary text-white rounded btn-sm"
                        onClick={() => onEdit(service)}
                      >
                        Edit <MdEdit />
                      </button>
                      <span
                        style={{ fontSize: "20px", cursor: "pointer" }}
                        onClick={(e) => toggleMenu(service.Id, e)}
                      >
                        <span>
                          <VscKebabVertical style={{ marginTop: "2px" }} />
                        </span>
                      </span>
                      {openMenuId === service.Id && (
                        <div className="service-menu cursor-pointer">
                          <p
                            onClick={() => onDelete(service)}
                            className="bg-danger rounded text-white p-1 "
                            style={{ cursor: "pointer" }}
                          >
                            Delete <MdDelete />
                          </p>
                        </div>
                      )}
                    </Col>
                  </Row>
                  <h4>{service.listName}</h4>
                  {(service.hourlyPrice !== "" ||
                    JSON.parse(service.dealPackage)?.length > 0) && (
                    <h6 style={{ color: "#616bff" }}>
                      ${" "}
                      {service.hourlyPrice
                        ? service.hourlyPrice
                        : getMinPackagePrice(JSON.parse(service.dealPackage))}
                    </h6>
                  )}
                </Col>
              </Row>
            </div>
          ))}
        </div>
      ) : (
        !isLoading && <div className="ads">No Pending Services</div>
      )}
      <Modal
        isOpen={limitModal}
        toggle={() => {
          setLimitModal(false);
          setLimitService(null);
          setLimit("");
        }}
      >
        <ModalBody>
          <ModalHeader>
            Set a customer gotton limit for vendor for the month of{" "}
            <span className="fw-bold text-decoration-underline">
              {monthName}
            </span>
          </ModalHeader>
          {gottonData && Object?.keys(gottonData).length > 0 ? (
            <Table responsive striped bordered className="m-0">
              <thead className="text-center text-nowrap">
                <tr>
                  <th>Month</th>
                  <th>Customer Gotten</th>
                  <th>Remaining</th>
                  <th>Limit</th>
                </tr>
              </thead>
              <tbody className="text-center text-nowrap">
                <tr>
                  <td>{moment(gottonData.MONTH).format("MMMM YYYY")}</td>
                  <td>{+gottonData.totalMessages}</td>
                  <td>{Math.max(+limit - +gottonData.totalMessages, 0)}</td>
                  <td>
                    <Input
                      type="text"
                      className="p-0 text-center"
                      value={limit}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          value === "" ||
                          (/^\d{1,4}$/.test(value) && Number(value) <= 999)
                        ) {
                          setLimit(value);
                        }
                      }}
                      max={999}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          ) : (
            <Table responsive striped bordered className="m-0">
              <thead className="text-center text-nowrap">
                <tr>
                  <th>Month</th>
                  <th>Customer Gotten</th>
                  <th>Remaining Left</th>
                  <th>Limit</th>
                </tr>
              </thead>
              <tbody className="text-center text-nowrap">
                <tr>
                  <td>{`${monthName} ${year}`}</td>
                  <td>0</td>
                  <td>0</td>
                  <td>
                    <Input
                      type="text"
                      className="p-0 text-center"
                      value={limit}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          value === "" ||
                          (/^\d{1,4}$/.test(value) && Number(value) <= 999)
                        ) {
                          setLimit(value);
                        }
                      }}
                      max={999}
                    />
                  </td>r
                </tr>
              </tbody>
            </Table>
          )}
        </ModalBody>
        <ModalFooter>
          <div className={`d-flex justify-content-end`}>
            <Button
              color="success"
              className="me-2"
              onClick={() => onApprove(limitService)}
            >
              Save
            </Button>
            <Button
              color="danger"
              className="ms-2"
              onClick={() => {
                setLimitModal(false);
                setLimitService(null);
                setLimit("");
              }}
            >
              Cancel
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PendingServices;
